import { render, staticRenderFns } from "./specialty-list.vue?vue&type=template&id=74ae3f80&scoped=true&"
import script from "./specialty-list.vue?vue&type=script&lang=js&"
export * from "./specialty-list.vue?vue&type=script&lang=js&"
import style0 from "./specialty-list.vue?vue&type=style&index=0&id=74ae3f80&scoped=true&lang=less&"
import style1 from "./specialty-list.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ae3f80",
  null
  
)

export default component.exports